import { isAxiosError } from 'axios'

export type ParsedPosError = {
  message: string
  code?: string
  details?: unknown
  status?: number
}

/** User-facing sentence for queue rows (plain language). */
export function plainLanguageForPosError(code: string | undefined, fallbackMessage: string): string {
  switch (code) {
    case 'INSUFFICIENT_STOCK_ON_SYNC':
      return 'Not enough stock for an item — reduce quantities or remove the sale from the queue.'
    case 'STOCK_CONFLICT':
      return 'A product is no longer available — edit the sale or remove it from the queue.'
    case 'INVALID_ITEMS':
      return 'One or more products are not valid for this store.'
    case 'POS_DISABLED':
      return 'POS is turned off for this store.'
    default:
      return fallbackMessage
  }
}

/** Handles Axios errors and `createPosSale` thrown `Error` with `status` / `code` / `details`. */
export function parsePosSaleError(err: unknown): ParsedPosError {
  if (err instanceof Error) {
    const e = err as Error & { status?: number; code?: string; details?: unknown }
    if (e.status != null || e.code != null || e.details != null) {
      return {
        message: err.message || 'Request failed',
        code: e.code,
        details: e.details,
        status: e.status,
      }
    }
  }
  if (!isAxiosError(err) || !err.response?.data || typeof err.response.data !== 'object') {
    const msg = err instanceof Error ? err.message : 'Request failed'
    return { message: msg }
  }
  const data = err.response.data as {
    message?: string
    error?: { code?: string; details?: unknown }
  }
  const message = typeof data.message === 'string' ? data.message : 'Request failed'
  const code = data.error?.code
  const details = data.error?.details
  return {
    message,
    code,
    details,
    status: err.response.status,
  }
}
